var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#list_svg__clip0_61530_7297)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5H7.5V6H21V4.5zM21 18H7.5v1.5H21V18zM21 11.25H7.5v1.5H21v-1.5zM4.5 11.25H3v1.5h1.5v-1.5zM4.5 4.5H3V6h1.5V4.5zM4.5 18H3v1.5h1.5V18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "list_svg__clip0_61530_7297"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgList;